module.exports = __webpack_public_path__ + "assets/img/piave.fbb6d1a7.png";